import angular from 'angular';
import template from './qr.html';
import QrComponent from './qr.component';

const qrConfig = /* @ngInject */ (/** @type {any} */ KformComponentsProvider) => {
	KformComponentsProvider.register('qr', {
		title:      'QR code',
		group:      'advanced',
		template,
		views:      [
			{
				name:     'Display',
				template: 'kform/components/qr/display.html',
			},
			{
				name:     'Validation',
				template: 'kform/components/common/validate.html',
			},
			{
				name:     'API',
				template: 'kform/components/qr/api.html',
			},
			{
				name:     'Conditional',
				template: 'kform/components/common/conditional.html',
			},
		],
		children:   false,
		selectable: true,
		settings:   new QrComponent(),
		icon:       'fa fa-qrcode',
	});
};

export default angular.module('app').config(qrConfig);
